export class UnauthenticatedException extends Error {
  name = 'UnauthenticatedError';
  response: Response;
  constructor(response: Response) {
    super(`Response failed as unauthenticated (${response.status})`);
    this.response = response;
  }
}

export class NotFoundException extends Error {
  name = 'NotFoundError';
  response: Response;
  constructor(response: Response) {
    super();
    this.response = response;
  }
}

export class ValidationException extends Error {
  name = 'ValidationError';
  response: Response;
  /** All of the data from the response */
  data: Record<string, unknown>;
  /** Errors from the response data (convenience accessor) */
  errors: Record<string, string[]>;

  constructor(data: Record<string, unknown>, response: Response) {
    super();
    this.response = response;
    this.errors = (data.errors ?? {}) as Record<string, string[]>;
    this.data = data;
  }
}

export class InternalServerException extends Error {
  name = 'InternalServerError';
  response: Response;
  constructor(response: Response) {
    super();
    this.response = response;
  }
}

export class BadResponseException extends Error {
  name = 'BadResponseError';
  response: Response;
  constructor(response: Response, message?: string) {
    super();
    this.response = response;
    this.message = message ?? 'Bad Response';
  }
}

export class TimeoutException extends Error {
  constructor(message?: string) {
    super(message ?? 'Request timeout');
  }
}

export class NetworkException extends Error {
  constructor(message?: string) {
    super(message ?? 'Network error');
  }
}

export class RateLimitException extends Error {
  response: Response;
  constructor(response: Response) {
    super();
    this.response = response;
  }
}
